import {
  LuCalendarRange, LuChartColumn, LuChartLine, LuCircleCheck, LuCirclePlus, LuClock,
  LuColumns3, LuCopy, LuFlag, LuFolderKanban, LuGauge, LuLayoutGrid, LuList, LuListChecks,
  LuPalette, LuSearch, LuSettings, LuSlidersHorizontal, LuTimer, LuUsers, LuZap,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
// The landing scope stays a prefix so /projects/overview (same page) is covered.
const tours = [
  tour('projects', '/projects', 'projects', [
    ['tabs', 'projects.tabs', LuFolderKanban],
    ['new', 'projects.new', LuCirclePlus, opt],
    ['filters', 'projects.filters', LuSlidersHorizontal, opt],
  ]),

  // ── Module tabs ──────────────────────────────────────────────────────────
  tour('projects_list', '/projects/list', 'projects', [
    ['kpis', 'projects_list.kpis', LuChartColumn],
    ['create', 'projects_list.create', LuCirclePlus, { placement: 'left', ...opt }],
    ['filters', 'projects_list.filters', LuSearch],
    ['cards', 'projects_list.cards', LuLayoutGrid, { placement: 'top', ...opt }],
  ], { exact: true }),

  tour('projects_my_tasks', '/projects/my-tasks', 'projects', [
    ['kpis', 'projects_my_tasks.kpis', LuListChecks],
    ['search', 'projects_my_tasks.search', LuSearch],
    ['view', 'projects_my_tasks.view', LuSlidersHorizontal, { placement: 'left' }],
  ], { exact: true }),

  tour('projects_timesheets', '/projects/timesheets', 'projects', [
    ['kpis', 'projects_timesheets.kpis', LuClock],
    ['status', 'projects_timesheets.status', LuCircleCheck],
    ['table', 'projects_timesheets.table', LuList, { placement: 'top' }],
  ], { exact: true }),

  tour('projects_workload', '/projects/workload', 'projects', [
    ['kpis', 'projects_workload.kpis', LuUsers],
    ['legend', 'projects_workload.legend', LuPalette],
    ['table', 'projects_workload.table', LuGauge, { placement: 'top' }],
  ], { exact: true }),

  tour('projects_templates', '/projects/templates', 'projects', [
    ['new', 'projects_templates.new', LuCopy, { placement: 'left' }],
    ['grid', 'projects_templates.grid', LuLayoutGrid, { placement: 'top', ...opt }],
  ], { exact: true }),

  // ── Tabs of one project (/projects/:id/*) ────────────────────────────────
  // ProjectLayout marks its content `projects_project_<tab>` on these pages.
  tour('projects_project_overview', null, 'projects', [
    ['summary', 'projects_project_overview.summary', LuFolderKanban],
    ['kpis', 'projects_project_overview.kpis', LuChartColumn],
    ['progress', 'projects_project_overview.progress', LuChartLine, { placement: 'top' }],
  ], { page: 'projects_project_overview' }),

  tour('projects_project_board', null, 'projects', [
    ['columns', 'projects_project_board.columns', LuColumns3, { placement: 'top' }],
    ['create', 'projects_project_board.create', LuCirclePlus, { placement: 'left', ...opt }],
  ], { page: 'projects_project_board' }),

  tour('projects_project_list', null, 'projects', [
    ['table', 'projects_project_list.table', LuList, { placement: 'top' }],
    ['filter', 'projects_project_list.filter', LuSearch],
    ['create', 'projects_project_list.create', LuCirclePlus, { placement: 'left', ...opt }],
  ], { page: 'projects_project_list' }),

  tour('projects_project_gantt', null, 'projects', [
    ['chart', 'projects_project_gantt.chart', LuCalendarRange, { placement: 'top' }],
    ['toolbar', 'projects_project_gantt.toolbar', LuSlidersHorizontal],
  ], { page: 'projects_project_gantt' }),

  tour('projects_project_milestones', null, 'projects', [
    ['header', 'projects_project_milestones.header', LuFlag],
    ['new', 'projects_project_milestones.new', LuCirclePlus, { placement: 'left', ...opt }],
    ['upcoming', 'projects_project_milestones.upcoming', LuList, { placement: 'top', ...opt }],
  ], { page: 'projects_project_milestones' }),

  tour('projects_project_sprints', null, 'projects', [
    ['header', 'projects_project_sprints.header', LuZap],
    ['new', 'projects_project_sprints.new', LuCirclePlus, { placement: 'left', ...opt }],
    ['toolbar', 'projects_project_sprints.toolbar', LuSearch],
  ], { page: 'projects_project_sprints' }),

  tour('projects_project_timesheets', null, 'projects', [
    ['kpis', 'projects_project_timesheets.kpis', LuTimer],
    ['log', 'projects_project_timesheets.log', LuCirclePlus, { placement: 'left', ...opt }],
    ['table', 'projects_project_timesheets.table', LuList, { placement: 'top' }],
  ], { page: 'projects_project_timesheets' }),

  tour('projects_project_reports', null, 'projects', [
    ['header', 'projects_project_reports.header', LuChartLine],
    ['kpis', 'projects_project_reports.kpis', LuChartColumn, opt],
    ['charts', 'projects_project_reports.charts', LuChartLine, { placement: 'top', ...opt }],
  ], { page: 'projects_project_reports' }),

  tour('projects_project_settings', null, 'projects', [
    ['header', 'projects_project_settings.header', LuSettings],
    ['sections', 'projects_project_settings.sections', LuSlidersHorizontal, { placement: 'top', ...opt }],
  ], { page: 'projects_project_settings' }),
];

export default tours;
